import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCreditCard01 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.6663 6.66732H1.33301M1.33301 5.46732L1.33301 10.534C1.33301 11.2807 1.33301 11.6541 1.47833 11.9393C1.60616 12.1902 1.81014 12.3942 2.06102 12.522C2.34624 12.6673 2.7196 12.6673 3.46634 12.6673L12.533 12.6673C13.2797 12.6673 13.6531 12.6673 13.9383 12.522C14.1892 12.3942 14.3932 12.1902 14.521 11.9393C14.6663 11.6541 14.6663 11.2807 14.6663 10.534V5.46732C14.6663 4.72058 14.6663 4.34721 14.521 4.062C14.3932 3.81112 14.1892 3.60714 13.9383 3.47931C13.6531 3.33399 13.2797 3.33399 12.533 3.33399L3.46634 3.33398C2.7196 3.33398 2.34624 3.33398 2.06102 3.47931C1.81014 3.60714 1.60616 3.81111 1.47833 4.062C1.33301 4.34721 1.33301 4.72058 1.33301 5.46732Z",
		stroke: "currentColor",
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCreditCard01;
